import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-2xl text-accent-500" />
                </div>
                <span className="text-lg font-bold font-heading text-background-50">{siteInfo.name}</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                {siteInfo.slogan}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#nav-section" className="cursor-pointer">快速导航</a>
              </h4>
              <ul className="space-y-2.5">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#about-section" className="cursor-pointer">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#contact-section" className="cursor-pointer">联系方式</a>
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-sm" />
                  </div>
                  {siteInfo.email}
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-sm" />
                  </div>
                  {siteInfo.phone}
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm" />
                  </div>
                  {siteInfo.address}
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 md:mt-12 pt-8 border-t border-background-700/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-400">
                &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
              </p>
              <p className="text-xs text-background-400">
                {siteInfo.icp}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}